import { Module } from 'vuex'

import { ItemState, RootState } from '@/types/store'

import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

const state: ItemState = {
  itemType: 'new',
  items: [],
  total: -1,
  isItemsLoading: false,
}

export const item: Module<ItemState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
